import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {updateTextInput} from "../../../actions";
import {styled} from "@mui/material";

import Slider from '@mui/material/Slider';
import markdownIt from 'markdown-it';
import mila from "markdown-it-link-attributes";

let md = markdownIt({ html: false, linkify: true, typographer: true, breaks: false });
md.use(mila, { attrs: { target: "_blank", rel: "noopener", } });


const BPBoxShadow = '0px 3px 8px #00000026';
const BPSlider = styled(Slider)(({theme}) => ({
	height: 5,
	padding: '15px 0',
	'& .MuiSlider-thumb': {
		height: 24,
		width: 24,
		backgroundColor: '#fff',
		boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
		'&:focus, &:hover, &.Mui-active': {
			boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
			// Reset on touch devices, it doesn't add specificity
			'@media (hover: none)': {
				boxShadow: BPBoxShadow,
			},
		},
		'&:before': {
			boxShadow:
				'0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
		},
	},
	'& .MuiSlider-valueLabel': {
		fontSize: 16,
		fontWeight: 'normal',
		top: 58,
		backgroundColor: 'unset',
		color: theme.palette.text.primary,
		'&::before': {
			display: 'none',
		},
		'& *': {
			background: 'transparent',
			color: theme.palette.mode === 'dark' ? '#fff' : '#000',
		},
	},
	'& .MuiSlider-track': {
		border: 'none',
		height: 5,
	},
	'& .MuiSlider-rail': {
		opacity: 0.5,
		boxShadow: 'inset 0px 0px 4px -2px #000',
		backgroundColor: '#d0d0d0',
	},
}));

export default function Range(props: any) {
	const {message, currentIndex, count, topMargin} = props;
	const [range, setRange] = useState<number[]>([1, 100]);

	const dispatch = useDispatch();
	const design = useSelector((state: any) => state?.design);
	const direction = useSelector((state: any) => state?.environment?.direction);

	const rangeSlide = (event: Event, newValue: number | number[]) => {
		setRange(newValue as number[]);
	};

	useEffect(() => {
		if (currentIndex === (count - 1)) {
			dispatch(updateTextInput({
				value: `${props.message.rangePrefix || ''} ${range[0]} ${props.message.rangeSuffix || ''} ${range[1]}`
			}));
		}

		return () => {
			if (currentIndex === (count - 1)) {
				dispatch(updateTextInput({
					value: '', original: ''
				}));
			}
		}
	}, [range, props, dispatch, currentIndex, count]);
	return <>
		<div className="w-4/6 ele-range">
			<div className={`ele-range-message-label rounded-xl py-2 px-4 w-fit bg-primaryBgColor ${topMargin}`}>
				<p className="prose" dangerouslySetInnerHTML={{ __html: md.render(message.label) }} />
			</div>
			{
				(currentIndex === (count - 1) && (
					<div className="range-slider w-100 flex items-center mt-1">
						<span style={{marginLeft: 20}} className='text-gray-400 mr-2 ele-range-min-range'>{message.minRange || 0}</span>
						<BPSlider
							getAriaLabel={() => 'Temperature range'}
							value={range}
							style={{color: design.themeColor}}
							onChange={rangeSlide}
							valueLabelDisplay="auto"
							min={message.minRange || 0}
							max={message.maxRange || 100}
							step={message.rangeStep || 1}
							// getAriaValueText={valuetext}
						/>
            <span style={{marginLeft: 20}} className={`text-gray-400 ele-range-max-range ${ direction === 'rtl' ? 'mr-4' : 'mr-2' }`}>{message.maxRange || 100}</span>
					</div>
				))
			}
		</div>

	</>
} 